/* eslint-disable */

const getDefaultState = () => {
    const savedOrg = localStorage.getItem("organisation");
    try {
        return {
            selectedOrganisation: savedOrg ? JSON.parse(savedOrg) : null,
        }
    } catch (e) {
        // If parsing fails, default to null and remove the invalid item.
        localStorage.removeItem("organisation");
        return {
            selectedOrganisation: null,
        }
    }
};

const state = getDefaultState();

const actions = {
    /**
     * Action to select an organisation and save it to the state and localStorage.
     * The localStorage part ensures it's immediately available on page reload
     * before the persisted state rehydrates.
     */
    selectOrganisation({ commit }, organisation) {
        commit('SET_SELECTED_ORGANISATION', organisation);
        // Also save to localStorage for immediate access on redirects/reloads
        localStorage.setItem("organisation", JSON.stringify(organisation));
    },

    /**
     * Clears the selected organisation from the state.
     */
    clearOrganisation({ commit }) {
        commit('RESET_STATE');
        localStorage.removeItem("organisation");
    }
};

const mutations = {
    SET_SELECTED_ORGANISATION(state, organisation) {
        state.selectedOrganisation = organisation;
    },
    RESET_STATE(state) {
        Object.assign(state, getDefaultState());
    },
};

const getters = {
    selectedOrganisation: state => state.selectedOrganisation,
    selectedOrgId: state => state.selectedOrganisation?.id || null,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};